/**
 * @author jakubmaslon
 * @since 2020-09-23
 */

import * as React from "react";

import { TestWrapper } from "@ui/Atoms/TestWrapper";

import { HeaderTabLink } from "./HeaderTabLink";
import { HeaderTabs } from "./HeaderTabs";

interface Tab {
  testId?: string;
  to: string;
  label: string;
}

interface Props {
  tabs: Tab[];
  className?: string;
}

const HeaderTabsWLinks = (props: Props): React.ReactElement => (
  <HeaderTabs className={props.className}>
    {props.tabs.map((tab: Tab) => (
      <TestWrapper testId={tab.testId} key={tab.testId}>
        <HeaderTabLink to={tab.to}>{tab.label}</HeaderTabLink>
      </TestWrapper>
    ))}
  </HeaderTabs>
);

export { HeaderTabsWLinks };
